import Model, { attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type StringTransform from 'teacher-ui-client/transforms/string'

export default class Accent extends Model {
  @attr<StringTransform>('string') declare extension: string

  @attr<StringTransform>('string') declare description: string;

  [Type] = 'accent' as const
}
